module.exports = __webpack_public_path__ + "img/About_Employers_LIGHT-03.11911c0.svg";